import { formatNumber } from '@angular/common';
import { Injectable, LOCALE_ID, inject } from '@angular/core';

import { JackpotValueModel } from './jackpot-value.model';

@Injectable({ providedIn: 'root' })
export class JackpotValueSerializer {
    private _currLocale = inject(LOCALE_ID);

    serialize(value: JackpotValueModel | undefined, withCurrency = true, currencyOnRight = false, withAmount = true): string {
        if (value) {
            const formattedAmount = withAmount ? formatNumber(value.amount, this._currLocale, '2.2-2') || '' : '';
            if (withCurrency) {
                return currencyOnRight ? `${formattedAmount} ${value.currency}` : `${value.currency} ${formattedAmount}`;
            } else {
                return formattedAmount;
            }
        }
        return '';
    }

    deserialize(valueStr: string): JackpotValueModel | undefined {
        if (!valueStr) {
            return;
        }
        const nbsplessValueStr = valueStr.replace(/&nbsp;/g, '');
        const currency = this.deserializeCurrency(nbsplessValueStr);
        const currencylessValueStr = nbsplessValueStr.replace(currency, '');
        const numericValue = this.deserializeAmount(currencylessValueStr);

        return { currency, amount: numericValue };
    }

    private deserializeAmount(valueStr: string): number {
        const spacelessValueStr = valueStr.replace(/ /g, '');
        const commalessValueStr = spacelessValueStr.replace(/,/g, '');
        const dotlessValueStr = commalessValueStr.replace(/\./g, '');
        const whitespacelessValueStr = dotlessValueStr.replace(/\s/g, '');

        const possiblyNumericValueStr = whitespacelessValueStr.match(/\b[\d, ]+\b/g)?.[0] ?? '';
        let decimalRealParts = possiblyNumericValueStr;
        if (possiblyNumericValueStr.length > 2) {
            const butFromLast = -2;
            const realpart = possiblyNumericValueStr.slice(0, butFromLast);
            const decimalpart = possiblyNumericValueStr.slice(butFromLast);
            decimalRealParts = `${realpart}.${decimalpart}`;
        }

        return parseFloat(decimalRealParts.replace(/,/g, ''));
    }

    private deserializeCurrency(valueStr: string): string {
        const initialcurrency = valueStr.match(/[^\d.,\s]/g);
        let currency = '';

        if (initialcurrency && initialcurrency.length > 0) {
            for (let i = 0; i < initialcurrency.length; i++) {
                currency = currency + initialcurrency[i];
            }
            currency = currency.replace(/,/g, '');
            currency = currency.replace(/\./g, '');
        }
        return currency;
    }
}
